import { useContext } from 'react';
import { SpecialCareChartsDataContext } from '../contexts/SpecialCareChartsDataContext';

export const useSpecialCareChartsDataContext = () => {
    return useContext(SpecialCareChartsDataContext);
};
